import { Sorting } from "@app/models/paginateList";

export class FolderListFilter {
    indirizzo!: string;
    destinazioniUso!: string;
    comune!: string;
    sbarramento!: number;
    dataDal!: string;
    dataAl!: string;
    stato!: string;
    tutti!: boolean;
    codice!: string;

    constructor(init?: Partial<FolderListFilter>) {
        Object.assign(this, init);
    }
}

export enum LabelMap {
    indirizzo = "address",
    destinazioniUso = "purpose",
    comune = "municipality",
    sbarramento = "barrier",
    dataDal = "created.from",
    dataAl = "created.to",
    stato = "state",
    codice = "code",
    tutti = "all-versions"
}

export const sortList: Sorting[] = [
    { campo: "aggiornamento", verso: "DESC" },
    { campo: "aggiornamento", verso: "ASC" },
    { campo: "sbarramento.denominazione", verso: "DESC" },
    { campo: "sbarramento.denominazione", verso: "ASC" },
    { campo: "stato.nome", verso: "DESC" },
    { campo: "stato.nome", verso: "ASC" },
];
